import React, { useState, useEffect, useRef } from 'react';
import axios from "axios";
import Select from 'react-select';
import classNames from 'classnames';



const FieldSearch = (props) => {
	const [query, setQuery] = useState(props.searchedString);

	const toggleCleaner = () => {
		if(query != ''){
			return (<button type="button" className="icon-btn icon-after" onClick={(e) => {setQuery('');}}><i class="fa-solid fa-delete-left "></i></button>)
		}
	}

	useEffect(() => {
		if(query != props.searchedString){
		const timeOutId = setTimeout(() => {props.setSearchedString(query);toggleCleaner()}, 1000);
		return () => clearTimeout(timeOutId);
		}
	  }, [query]);
	return (
        <>
        <div class="input-icons">
			<i class="fa-solid fa-magnifying-glass icon-before"></i>
			{toggleCleaner()}
        	<input type="text" className="form-control" name="q" placeholder="Diplôme, métier, certification..." value={query} onChange={(e) => {setQuery(e.target.value); }} />
			
		</div>
		</>
    );
}
const FieldTheme = (props) => {
	let options = formThemes;
	//const options = props.filterTheme;

	const HandleChange = (obj) => {
		if(obj.key!=''){
			options[0].label = "Tous";
		}else{
			options[0].label = "Domaine";
		}
		props.setSearchedTheme(obj);

	};
    return (
		<>
		<Select
			isSearchable
			placeholder="Domaine"
			onChange={(option) => HandleChange(option)}
			options={options}
			value={props.searchedTheme}
			defaultValue={props.searchedTheme}
			getOptionValue={option => option.key}
			getOptionLabel={(option) => option.label}
			className="react-select-container"
			classNamePrefix="react-select"
			noOptionsMessage={() => "Aucun domaine disponible"} 
			classNames={{
				control: ({ isDisabled, isFocused }) =>
					classNames(
						!isDisabled && isFocused && 'react-select-isFocused',
						isFocused && 'react-select-isFocused',
						isFocused && 'react-select-isFocused'
					),
				option: ({ isDisabled, isFocused, isSelected }) =>
					classNames(
						isSelected && 'react-select-isSelected',
						!isSelected && isFocused && 'react-select-isDefault',
						!isDisabled && isSelected && 'active:react-select-isSelected',
						!isDisabled && !isSelected && 'active:react-select-isDefault'
					),
			}}
		/>
		</>
	)

}
const FieldFormat = (props) => {

	const options = formFormats;
	//const options = props.filterFormat;

	const HandleChange = (obj) => {
		//console.log(obj)
		if(obj.key!=''){
			options[0].label = "Tous";
		}else{
			options[0].label = "Format";
		}
		props.setSearchedFormat(obj);
	};
    return (
		<>
		<Select
			placeholder="Format"
			onChange={(option) => HandleChange(option)}
			options={options}
			value={props.searchedFormat}
			defaultValue={props.searchedFormat}
			getOptionValue={option => option.key}
			getOptionLabel={(option) => option.label}
			className="react-select-container"
			classNamePrefix="react-select"
			noOptionsMessage={() => "Aucun format disponible"} 
			classNames={{
				control: ({ isDisabled, isFocused }) =>
					classNames(
						!isDisabled && isFocused && 'react-select-isFocused',
						isFocused && 'react-select-isFocused',
						isFocused && 'react-select-isFocused'
					),
				option: ({ isDisabled, isFocused, isSelected }) =>
					classNames(
						isSelected && 'react-select-isSelected',
						!isSelected && isFocused && 'react-select-isDefault',
						!isDisabled && isSelected && 'active:react-select-isSelected',
						!isDisabled && !isSelected && 'active:react-select-isDefault'
					),
			}}
		/>
		</>
	)
}
const FieldFinancement = (props) => {

	const options = formFinancements;
	//const options = props.filterFinancement;

	const HandleChange = (obj) => {
		if(obj.key!=''){
			options[0].label = "Tous";
		}else{
			options[0].label = "Financement";
		}
		props.setSearchedFinancement(obj);
	};

    return (
		<>
		<Select
			placeholder="Financement"
			onChange={(option) => HandleChange(option)}
			options={options}
			value={props.searchedFinancement}
			defaultValue={props.searchedFinancement}
			getOptionValue={option => option.key}
			getOptionLabel={(option) => option.label}
			className="react-select-container"
			classNamePrefix="react-select"
			noOptionsMessage={() => "Aucun financement disponible"} 
			classNames={{
				control: ({ isDisabled, isFocused }) =>
					classNames(
						!isDisabled && isFocused && 'react-select-isFocused',
						isFocused && 'react-select-isFocused',
						isFocused && 'react-select-isFocused'
					),
				option: ({ isDisabled, isFocused, isSelected }) =>
					classNames(
						isSelected && 'react-select-isSelected',
						!isSelected && isFocused && 'react-select-isDefault',
						!isDisabled && isSelected && 'active:react-select-isSelected',
						!isDisabled && !isSelected && 'active:react-select-isDefault'
					),
			}}
		/>
		</>
	)
}
const FieldVille = (props) => {
	const options = formVilles;
	//const options = props.filterVille;

	const HandleChange = (obj) => {
		if(obj.key!=''){
			options[0].label = "Tous";
		}else{
			options[0].label = "Lieu de formation";
		}
		props.setSearchedVille(obj);
	};
    return (
		<>
		<Select
			isSearchable
			placeholder="Lieu de formation"
			onChange={(option) => HandleChange(option)}
			options={options}
			value={props.searchedVille}
			defaultValue={props.searchedVille}
			getOptionValue={option => option.key}
			getOptionLabel={(option) => option.label}
			className="react-select-container"
			classNamePrefix="react-select"
			noOptionsMessage={() => "Aucun lieu disponible"} 
			classNames={{
				control: ({ isDisabled, isFocused }) =>
					classNames(
						!isDisabled && isFocused && 'react-select-isFocused',
						isFocused && 'react-select-isFocused',
						isFocused && 'react-select-isFocused'
					),
				option: ({ isDisabled, isFocused, isSelected }) =>
					classNames(
						isSelected && 'react-select-isSelected',
						!isSelected && isFocused && 'react-select-isDefault',
						!isDisabled && isSelected && 'active:react-select-isSelected',
						!isDisabled && !isSelected && 'active:react-select-isDefault'
					),
			}}
		/>
		</>
	)
}
const FieldType = (props) => {
	const options = formTypes;
	//const options = props.filterType;

	const HandleChange = (obj) => {
		if(obj.key!=''){
			options[0].label = "Tous";
		}else{
			options[0].label = "Type";
		}
		props.setSearchedType(obj);
	};
    return (
		<>
		<Select
			placeholder="Type"
			onChange={(option) => HandleChange(option)}
			options={options}
			value={props.searchedType}
			//isMulti
			defaultValue={props.searchedType}
			getOptionValue={option => option.key}
			getOptionLabel={(option) => option.label}
			className="react-select-container"
			classNamePrefix="react-select"
			noOptionsMessage={() => "Aucun type disponible"} 
			classNames={{
				control: ({ isDisabled, isFocused }) =>
					classNames(
						!isDisabled && isFocused && 'react-select-isFocused',
						isFocused && 'react-select-isFocused',
						isFocused && 'react-select-isFocused'
					),
				option: ({ isDisabled, isFocused, isSelected }) =>
					classNames(
						isSelected && 'react-select-isSelected',
						!isSelected && isFocused && 'react-select-isDefault',
						!isDisabled && isSelected && 'active:react-select-isSelected',
						!isDisabled && !isSelected && 'active:react-select-isDefault'
					),
			}}
		/>
		</>
	)
}

const Formation = (props) => {
	const item = props.item;
	const index = props.index;

	const renderTypeValidation = () => {
		if(item.type!=''){
			return(
				<div className="gei-label type-validation">Formation&nbsp;{item.type}</div>
			)
		}
	}

	return (
		<div key={ 'formation-' + index } className="col-12 col-md-6 col-lg-4 col-xl-3 pt-4">
			<div className="white-box d-flex flex-column justify-content-start align-items-start h-100">
				<div className="position-relative">
					<div className="thumb-placeholder"><a href={item.permalink}><img src={item.thumbnail} className="img-fluid wp-post-image" loading="lazy" decoding="async" width="400" height="204" alt={item.designation} /></a></div>
					<div class="theme-icons position-absolute top-0 start-0 p-1 d-flex justify-content-start align-items-start">
					{item.themes.map( ( t, i ) => {
						const themeStyle = {
							backgroundColor: t.couleur
						}
						if(t.url != null){
							return (<div className="theme-icon me-1" style={themeStyle}><img src={t.url} width="30" height="30" className="m-2" alt={t.label} /></div>)
						}
					})}
					</div>
					
				</div>
				<a href={item.permalink} className="box-title pt-2">{item.designation}</a>
				<hr />
				<div className="gei-label-list">
					{renderTypeValidation()}
					<div className="gei-label type-validation">{item.duree}&nbsp;{item.duree > 1 ? 'jours':'jour'}</div>
				</div>
				<ul className="gei-icon-list mt-2">
				{item.supports.presentiel == 1 ? (<li className="gei-icon format">Présentiel</li>):''}
				{item.supports.distanciel == 1 ? (<li className="gei-icon format">Classe virtuelle</li>):''}
				{item.supports.web == 1 ? (<li className="gei-icon format">100% en ligne</li>):''}
				{item.supports.mixte == 1 ? (<li className="gei-icon format">Blended learning</li>):''}
				</ul>
				<ul className="gei-icon-list">
				{item.financements.map( ( fi, i ) => {
					return (<li className="gei-icon financement">{fi.designation}</li>)
				})}
				</ul>
				<div className="mt-auto w-100"><a href={item.permalink} class="white-box-btn mt-3"><span>Découvrir</span></a></div>
			</div>
		</div>
	);

}
const Formations = (props) => {

	const formations = props.formations.map( ( item, index ) => {

		return (

			<Formation
				item={item}
				index={index}
				
				/>
	
		);
	});

	const renderNoResults = () => {

		return(
			<div className=" mt-5">
				<p className="text-center t-weight-700 t-size-24 text-danger">Aucun résultat ne correspond à votre recherche</p>
			</div>
		);
	}
	const renderLoading = () => {
		return(
			<div className=" mt-5">
				<p className="text-center t-weight-700 t-size-24 text-grey"><div className="lds-ellipsis"><div></div><div></div><div></div><div></div></div></p>
			</div>
		);
	}
	const renderResults = () => {
		if(props.loading){
			return ( renderLoading() )
		}else if(props.totalFormations > 0){
			return(  formations  )
		}else{
			return ( renderNoResults() )
		}


	}
	return (
	  <>
		<div className="row">
		{renderResults()}
		</div>
	  </>
  )
}


const Formulaire = (props) => {

    const [filterTheme, setFilterTheme] = useState(props.searchedTheme);
    const [filterFormat, setFilterFormat] = useState(props.searchedFormat);
    const [filterFinancement, setFilterFinancement] = useState(props.searchedFinancement);
    const [filterVille, setFilterVille] = useState(props.searchedVille);
    const [filterType, setFilterType] = useState(props.searchedType);
	const url = props.baseUrl + '/wp-content/themes/eigroupe/forms/catalogue/filters.php';




	/*useEffect(() => {

		const fd = new FormData();
		fd.append('_qs', props.searchedString);
		fd.append('_th', props.searchedTheme.key);
		fd.append('_ft', props.searchedFormat.key);
		fd.append('_fi', props.searchedFinancement.key);
		fd.append('_vi', props.searchedVille.key);
		fd.append('_ty', props.searchedType.key);
		
		fd.append('action', "do_reajax");
		fd.append('fn', "geifilters_ajax");
		
		axios.post(url,fd).then(function (response) {
			if ( response.status === 200 && response.data ) {
				const data = response.data;
				setFilterTheme(data.themes)
				setFilterFormat(data.formats)
				setFilterFinancement(data.financements)
				setFilterVille(data.villes)
				setFilterType(data.types)
				
			}
		}).catch(function (error) {
			console.error( error );
		});

	}, [props]);*/



	const renderTheme = () => {
		if(props.pageTheme==''){
			return ( 
				<div className='col pb-4'><FieldTheme filterTheme={filterTheme} searchedTheme={props.searchedTheme} setSearchedTheme={props.setSearchedTheme} /></div>
			 )
		}
	}

	const renderVille = () => {
		if(props.pageVille==''){
			return ( 
				<div className='col pb-4'><FieldVille filterVille={filterVille} searchedVille={props.searchedVille} setSearchedVille={props.setSearchedVille} /></div>
			 )
		}
	}
	const renderRowClasses = () => {
		
		if(props.pageTheme==''){
			return ( 'row row-cols-2 row-cols-md-5')
		}else{
			return ( 'row row-cols-2 row-cols-md-4')
		}
	}
	return (
		<>
			<div className='row'>
				<div className='col-12 py-5 text-center'><FieldSearch searchedString={props.searchedString} setSearchedString={props.setSearchedString} /></div>
			</div>
			<div className={renderRowClasses()}>
				{renderTheme()}
				<div className='col pb-4'><FieldFormat filterFormat={filterFormat} searchedFormat={props.searchedFormat} setSearchedFormat={props.setSearchedFormat} /></div>
				<div className='col pb-4'><FieldFinancement filterFinancement={filterFinancement} searchedFinancement={props.searchedFinancement} setSearchedFinancement={props.setSearchedFinancement} /></div>
				{renderVille()}
				<div className='col pb-4'><FieldType filterType={filterType} searchedType={props.searchedType} setSearchedType={props.setSearchedType} /></div>
			</div>
		</>
	);
}

const Liste = (props) => {
	const [loading, setLoading] = useState(false);
    const [formations, setFormations] = useState([]);
    const [formationsPages, setFormationsPages] = useState([]);
    const [currentPage, setCurrentPage] = useState(props.defaultPage);
    const [totalPages, setTotalPages] = useState(0);
    const [totalFormations, setTotalFormations] = useState(0);
    const url = props.baseUrl + '/wp-content/themes/eigroupe/forms/catalogue/search.php';
	useEffect(() => {
		fetchData();
  	}, [loading,currentPage,totalPages,totalFormations,formationsPages,formations]);
	  useEffect(() => {
		  setFormations([])
		  setFormationsPages([])
		  setTotalPages(0)
		  setCurrentPage(1)
		  setLoading(false);
		  fetchData();
		}, [props]);
	const fetchData = () => {

		const page = currentPage;

		if ( loading ) {
			return;
		}
		let fd = new FormData();
		fd.append('_qs', props.searchedString);
		fd.append('_th', props.searchedTheme.key);
		fd.append('_ft', props.searchedFormat.key);
		fd.append('_fi', props.searchedFinancement.key);
		fd.append('_vi', props.searchedVille.key);
		fd.append('_ty', props.searchedType.key);
		fd.append('n', page);
		
		Object.entries(props.googleData).forEach(([key, value]) => {
			if (value != null && value !== '') {
				fd.append(key, value);
			}
		});
			

		var currentUrl = location.pathname;
		const formDataAsString = new URLSearchParams(fd).toString();
		var queryString = currentUrl+'?'+formDataAsString;

		fd.append('action', "do_reajax");
		fd.append('fn', "geisearch_ajax");
		fd.append('paged', page);


		window.history.replaceState({}, "", queryString);
		props.setDefaultPage = page
		if ( Object.keys( formationsPages ).indexOf( page.toString() ) >= 0 ) {
			return;
		}

		setLoading(true);

		axios.post(url,fd).then(function (response) {
			if ( response.status === 200 && response.data ) {
				const data = response.data;
				const posts = data.posts;
					setTotalPages(parseInt( data.max_pages ) );
				let _formations = [ ...formations, ...posts ];

				let _formationsPages = formationsPages;

				_formationsPages[ page ] = [];
				for( var a=0; a < posts.length; a++ ) {
					_formationsPages[ page ].push( posts[ a ].id );
				}
				setFormationsPages(_formationsPages) ;
				setFormations(_formations) ;
				setTotalFormations(data.total_posts) ;
				//props.setListeVilles(data.listeVilles)
				//formVilles = data.listeVilles
			}

      		setLoading(false);
      	}).catch(function (error) {
			console.error( error );
		});
	}

    return (
		<>
		<div className="row">
			<div className="col-12 col-md-6">
				<div>{totalFormations} {totalFormations > 1 ? 'formations trouvées':'formation trouvée'}</div>
			</div>
			<div className="col-12 col-md-6 text-end">
				<div className="catalogue-pagination">
				<Pagination
					refFormulaire={props.refFormulaire}
					currentPage={ currentPage }
					setCurrentPage={ setCurrentPage }
					totalPages={ totalPages }
				/>
			</div>
			</div>
		</div>
		

        <Formations
            currentPage={ currentPage }
            setCurrentPage={ setCurrentPage }
            formations={ getFormationsForPage( currentPage, formations, formationsPages ) }
            totalPages={ totalPages }
            totalFormations={ totalFormations }
            loading={ loading }
            />
		<div className="catalogue-pagination text-center pt-5">
			<Pagination
				refFormulaire={props.refFormulaire}
				currentPage={ currentPage }
				setCurrentPage={ setCurrentPage }
				totalPages={ totalPages }
			/>
		</div>
		</>
	)
}

const scrollTop = (ref) => {
	//window.scrollTo({top: 0, behavior: 'smooth'});
	ref.current?.scrollIntoView({ behavior: 'smooth' });
}
const Pagination = (props) => {
	let pagination = [];
	var currentPage = parseInt(props.currentPage)
	var nextPage = currentPage + 1 ;
	var limit = 24 ;
	var start = currentPage * limit;
	var startPagination = ((start-(2*limit))>1) ? (((start-(2*limit))/limit)) : 1;
	var endPagination = ((startPagination+4)<props.totalPages) ? (startPagination+4):props.totalPages;

	if(props.totalPages > 1){
		if(currentPage > 1){
			pagination.push( <a className="prev page-numbers" href="javascript:void(0);" rel="nofollow" onClick={ () => { props.setCurrentPage( currentPage-1 );scrollTop(props.refFormulaire); } }><i class="fa-solid fa-chevron-left"></i></a> );
		}
		if(startPagination>2){
			pagination.push( <a className="page-numbers" href="javascript:void(0);" rel="nofollow" onClick={ () => { props.setCurrentPage( 1 );scrollTop(props.refFormulaire); } }>1</a> );
			pagination.push(<span className="page-numbers">...</span> );
		}
		for( var p = startPagination; p <= endPagination; p++ ) {
			let page = p;
			if(currentPage == page){
				pagination.push( <a className="page-numbers current" href="javascript:void(0);" rel="nofollow" onClick={ () => { props.setCurrentPage( page );scrollTop(props.refFormulaire); } }>{ p }</a> );
			}else{
				pagination.push( <a className="page-numbers" href="javascript:void(0);" rel="nofollow" onClick={ () => { props.setCurrentPage( page );scrollTop(props.refFormulaire); } }>{ p }</a> );
			}

		}
		if(endPagination<props.totalPages-1){
			pagination.push(<span className="page-numbers">...</span> );
			pagination.push( <a className="page-numbers" href="javascript:void(0);" rel="nofollow" onClick={ () => { props.setCurrentPage( props.totalPages );scrollTop(props.refFormulaire); } }>{ props.totalPages }</a> );
		}
		if(currentPage < props.totalPages){
			pagination.push( <a className="next page-numbers" href="javascript:void(0);" rel="nofollow" onClick={ () => { props.setCurrentPage( currentPage+1 );scrollTop(props.refFormulaire); } }><i class="fa-solid fa-chevron-right"></i></a> );
		}
	}
	return (pagination)
}
const App = () => {

	// TODO : executer 2 requetes en ajax , une pour l'affichage, l'autre pour la mise à jour des filtres.

	const queryParams = new URLSearchParams(window.location.search);


	var _baseUrl = document.getElementById('gei_catalogue_form').getAttribute('data-url');
    var _defaultPage = queryParams.get("n") ? queryParams.get("n") : 1;
    var _defaultSearch = queryParams.get("_qs") ? queryParams.get("_qs") : '';
    var _defaultTheme = queryParams.get("_th") ? queryParams.get("_th") : 0;
    var _defaultFormat = queryParams.get("_ft") ? queryParams.get("_ft") : '';
    var _defaultFinancement = queryParams.get("_fi") ? queryParams.get("_fi") : 0;
    var _defaultVille = queryParams.get("_vi") ? queryParams.get("_vi") : '';
    var _defaultType = queryParams.get("_ty") ? queryParams.get("_ty") : '';
	_defaultType = _defaultType.indexOf('|') > -1 ? _defaultType.split('|')[0] : _defaultType;
	var _pageTheme = document.getElementById('gei_catalogue_form').getAttribute('data-theme');


    var _gclid = queryParams.get("gclid") ? queryParams.get("gclid") : '';
    var _gclsrc = queryParams.get("gclsrc") ? queryParams.get("gclsrc") : '';
    var _wbraid = queryParams.get("wbraid") ? queryParams.get("wbraid") : '';
    var _gbraid = queryParams.get("gbraid") ? queryParams.get("gbraid") : '';
    var _gl = queryParams.get("_gl") ? queryParams.get("_gl") : '';
    var _utm_id = queryParams.get("utm_id") ? queryParams.get("utm_id") : '';
    var _utm_source = queryParams.get("utm_source") ? queryParams.get("utm_source") : '';
    var _utm_medium = queryParams.get("utm_medium") ? queryParams.get("utm_medium") : '';
    var _utm_campaign = queryParams.get("utm_campaign") ? queryParams.get("utm_campaign") : '';
    var _utm_term = queryParams.get("utm_term") ? queryParams.get("utm_term") : '';
    var _utm_content = queryParams.get("utm_content") ? queryParams.get("utm_content") : '';
    var _utm_creative_format = queryParams.get("utm_creative_format") ? queryParams.get("utm_creative_format") : '';
    var _utm_marketing_tactic = queryParams.get("utm_marketing_tactic") ? queryParams.get("utm_marketing_tactic") : '';

	const _googleData = {
		gclid: _gclid,
		gclsrc: _gclsrc,
		wbraid: _wbraid,
		gbraid: _gbraid,
		gl: _gl,
		utm_id: _utm_id,
		utm_source: _utm_source,
		utm_medium: _utm_medium,
		utm_campaign: _utm_campaign,
		utm_term: _utm_term,
		utm_content: _utm_content,
		utm_creative_format: _utm_creative_format,
		utm_marketing_tactic: _utm_marketing_tactic,
	};

	if(_pageTheme != ''){
		_defaultTheme = _pageTheme
	}
	var _pageVille = document.getElementById('gei_catalogue_form').getAttribute('data-ville');
	if(_pageVille != ''){
		_defaultVille = _pageVille
	}
	formThemes.map((theme)=>{
		if(theme.key == _defaultTheme){
			_defaultTheme = {'key':theme.key,'label':theme.label}
		}
	})
	formFormats.map((format)=>{
		if(format.key == _defaultFormat){
			_defaultFormat = {'key':format.key,'label':format.label}
		}
	})
	formFinancements.map((financement)=>{
		if(financement.key == _defaultFinancement){
			_defaultFinancement = {'key':financement.key,'label':financement.label}
		}
	})
	formVilles.map((ville)=>{
		if(ville.key == _defaultVille){
			_defaultVille = {'key':ville.key,'label':ville.label}
		}
	})
	formTypes.map((type)=>{
		if(type.key == _defaultType){
			_defaultType = {'key':type.key,'label':type.label}
		}
	})
	const [defaultPage, setDefaultPage] = useState(_defaultPage!=undefined?_defaultPage:1);
    const [searchedString, setSearchedString] = useState(_defaultSearch);
    const [searchedTheme, setSearchedTheme] = useState(_defaultTheme);
    const [searchedFormat, setSearchedFormat] = useState(_defaultFormat);
    const [searchedFinancement, setSearchedFinancement] = useState(_defaultFinancement);
    const [searchedVille, setSearchedVille] = useState(_defaultVille);
    const [searchedType, setSearchedType] = useState(_defaultType);

    //const [listeVilles, setListeVilles] = useState(formVilles);

	const refFormulaire = useRef(null);
	//console.log('Thème : ',searchedTheme.key);
	//console.log('Financement : ',searchedFinancement.key);
	//console.log('Ville : ',searchedVille.key);
	//console.log('Format : ',searchedFormat.key);
	//console.log('Type : ',searchedType.key);
	return (
		<>
			<div className="catalogue-form" ref={refFormulaire}>
				<Formulaire 
					pageTheme={_pageTheme}
					pageVille={_pageVille}
					baseUrl={_baseUrl}
					//listeVilles={listeVilles}
					searchedString={searchedString} setSearchedString={setSearchedString}
					searchedTheme={searchedTheme} setSearchedTheme={setSearchedTheme}
					searchedFormat={searchedFormat} setSearchedFormat={setSearchedFormat}
					searchedFinancement={searchedFinancement} setSearchedFinancement={setSearchedFinancement}
					searchedVille={searchedVille} setSearchedVille={setSearchedVille}
					searchedType={searchedType} setSearchedType={setSearchedType}
				 />
			</div>
			<div className="catalogue-results">
				<Liste
				 	//setListeVilles={setListeVilles}
					refFormulaire={refFormulaire}
					baseUrl={_baseUrl}
					defaultPage={defaultPage} setDefaultPage={setDefaultPage} 
					searchedString={searchedString}
					searchedTheme={searchedTheme}
					searchedFormat={searchedFormat}
					searchedFinancement={searchedFinancement}
					searchedVille={searchedVille}
					searchedType={searchedType}
					googleData={_googleData}
				 />
			</div>
		</>
	);
}
export default App;


const getFormationsForPage = (page = 1, formations, formationsPages) => {
    let the_formations = [];
    if ( ! formationsPages[ page ] ) {
      	return [];
    }
    if ( formations.length === 0 ) {
      	return [];
    }


    for( var i = 0; i < formationsPages[page].length; i++ ) {
		var formationID = parseInt( formationsPages[page][i] );
		for( var a = 0; a < formations.length; a++ ) {
			if ( parseInt( formations[ a ].id ) === formationID ) {
				the_formations.push( formations[ a ] );

				break;
			}
		}
    }
    return the_formations;
}